import baseUrl from "../config/baseUrl";

const deleteDocumentRequestSettings = async ({ token, id }) => {
    const formData = new FormData();
    formData.append("id", id);

    try {
        const response = await fetch(
            `${baseUrl}/api/delete-document-request-setting-data?document_request_setting_id=${id}`,
            {
                method: "Delete",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            }
        );
        const data = await response.json();
        return data;
    } catch (error) {
        return error;
    }
};

export default deleteDocumentRequestSettings;
